<template>
<div>
  CheckBox
  <div class="d-flex">
    <preview
    v-if="getImage(config, lang)"
    :preview-id="getImage(config, lang)"
    source="asset"
    :asset-id="getImage(config, lang)"
    class="mini mr-2 align-self-end"
     />
     {{ getLabel(config, lang) }}
  </div>
  <div class="clickable slide-control-element mb-2" :key="index + forceReRenderKey" v-for="(option, index) in getOptions(config)">
    <div
      @click="selectUnselectItem(option)"
      :class="['checkbox', option.isFaulty ? 'faulty' : '', option.isSelected ? 'selected' : 'unselected']"><div class="inner"></div></div>
      {{ getText(option, lang) }} {{option.isCorrectAnswer}}
  </div>
</div>
</template>

<script>
import UtilsMixinJs from "@/components/vForm/viewer/UtilsMixin.js";
import Preview from "@/components/preview/Preview";

export default {
  name: "CheckBox",
  mixins: [UtilsMixinJs],
  components: {Preview},
  props: {
    config: {type: Object, required: true},
    lang: {type: String, required: true}
  },
  data() {
    return {
      selected: {},
    };
  },
  methods: {
      selectUnselectItem(option) {
        option.isSelected = !option.isSelected;
        this.forceReRenderKey++;
      },
      validate() {
        return this.validateOptions();
      },
      checkRequired() {
        return true;
      },
      getLogEntries() {
        return [];
      }
  }
}
</script>

<style lang="scss" scoped>
  .checkbox {
      width: 1.5rem;
      height: 1.5rem;
      background-color: lighten($highlight-color, 10%);
      float:left;
      margin-right: 8px;
      border: 1px solid transparent;
      position:relative;
      .inner {
        width: 95%;
        height: 95%;
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
      }
        &.selected, &:hover {
          .inner {
            background-color: darken($highlight-color, 10%);
          }
        }
        &.faulty {
          border: 1px solid red;
          .inner {
            border: 1px solid red;
          }
        }
  }
</style>